import React, { useState } from "react";
import "../../assets/players.css";
import PlayerLineChart from "../Analysis/LineChart";
import PlayerBarChart from "../Analysis/BarChart";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { analysisDescription } from "../Utils/functions";

const AnalysisTab = ({ analysis }) => {
  console.log("Analysis prop:", analysis.player_name);
  const [showBallHandling, setShowBallHandling] = useState(false);
  const [showScoring, setShowScoring] = useState(false);
  const [showRebounding, setShowRebounding] = useState(false);
  const [showDefense, setShowDefense] = useState(false);
  const [showPlaymaking, setShowPlaymaking] = useState(false);

  return (
    <div className="analysis-tab">
      <div
        style={{
          borderColor: analysisDescription(analysis.ball_handling).color,
        }}
        className="analysis-box"
      >
        <h2>Ball Handling</h2>{" "}
        <p
          className="analysis-tab-level"
          style={{
            color: analysisDescription(analysis.ball_handling).color,
          }}
        >
          {analysisDescription(analysis.ball_handling).level}
        </p>
        <PlayerBarChart
          chartType="ball_handling"
          player_score={analysis.ball_handling}
          player_name={analysis.player_name}
        />
        <div className="expand-section">
          <button
            className="expand-button"
            onClick={() => setShowBallHandling(!showBallHandling)}
          >
            {showBallHandling
              ? "Hide"
              : "See Ball Handling In Most Recent Games"}
            <ExpandMoreRoundedIcon
              sx={{ fontSize: 35 }}
              className={`expand-icon ${showBallHandling ? "rotated" : ""}`}
            />
          </button>
          {showBallHandling && (
            <PlayerLineChart
              chartType="ball_handling"
              player_score={analysis.ball_handling}
            />
          )}
        </div>
        {/* <p className="analysis-tab-description">
          Zylan Bernard is a skilled ball handler with a good handle on the
          ball. He has a quick first step and is able to change speeds to evade
          defenders.
        </p> */}
      </div>

      <div
        style={{
          borderColor: analysisDescription(analysis.scoring).color,
        }}
        className="analysis-box"
      >
        <h2>Scoring</h2>
        <p
          className="analysis-tab-level"
          style={{ color: analysisDescription(analysis.scoring).color }}
        >
          {analysisDescription(analysis.scoring).level}
        </p>
        <PlayerBarChart
          chartType="scoring"
          player_score={analysis.scoring}
          player_name={analysis.player_name}
        />

        <div className="expand-section">
          <button
            className="expand-button"
            onClick={() => setShowScoring(!showScoring)}
          >
            {showScoring ? "Hide" : "See Scoring In Most Recent Games"}
            <ExpandMoreRoundedIcon
              sx={{ fontSize: 35 }}
              className={`expand-icon ${showScoring ? "rotated" : ""}`}
            />
          </button>
          {showScoring && (
            <PlayerLineChart
              chartType="scoring"
              player_score={analysis.scoring}
            />
          )}
        </div>

        {/* <p className="analysis-tab-description">
          Bernard is a versatile scorer who can create his own shot or knock
          down open jumpers. He has a quick release on his jump shot and is
          accurate from the perimeter.
        </p> */}
      </div>

      <div
        style={{
          borderColor: analysisDescription(analysis.rebounding).color,
        }}
        className="analysis-box"
      >
        <h2>Rebounding</h2>
        <p
          className="analysis-tab-level"
          style={{
            color: analysisDescription(analysis.rebounding).color,
          }}
        >
          {analysisDescription(analysis.rebounding).level}
        </p>
        <PlayerBarChart
          chartType="rebounding"
          player_score={analysis.rebounding}
          player_name={analysis.player_name}
        />

        <div className="expand-section">
          <button
            className="expand-button"
            onClick={() => setShowRebounding(!showRebounding)}
          >
            {showRebounding ? "Hide" : "See Rebounding In Most Recent Games"}
            <ExpandMoreRoundedIcon
              sx={{ fontSize: 35 }}
              className={`expand-icon ${showRebounding ? "rotated" : ""}`}
            />
          </button>
          {showRebounding && (
            <PlayerLineChart
              chartType="rebounding"
              player_score={analysis.rebounding}
            />
          )}
        </div>

        {/* <p className="analysis-tab-description">
          Bernard is a solid rebounder who can box out and tip balls. He is
          active on the offensive glass and is able to tip balls to himself or
          teammates.
        </p> */}
      </div>
      <div
        style={{
          borderColor: analysisDescription(analysis.defense).color,
        }}
        className="analysis-box"
      >
        <h2>Defense</h2>{" "}
        <p
          className="analysis-tab-level"
          style={{
            color: analysisDescription(analysis.defense).color,
          }}
        >
          {analysisDescription(analysis.defense).level}
        </p>
        <PlayerBarChart
          chartType="defense"
          player_score={analysis.defense}
          player_name={analysis.player_name}
        />
        <div className="expand-section">
          <button
            className="expand-button"
            onClick={() => setShowDefense(!showDefense)}
          >
            {showDefense ? "Hide" : "See Defense In Most Recent Games"}
            <ExpandMoreRoundedIcon
              sx={{ fontSize: 35 }}
              className={`expand-icon ${showDefense ? "rotated" : ""}`}
            />
          </button>
          {showDefense && (
            <PlayerLineChart
              chartType="defense"
              player_score={analysis.defense}
            />
          )}
        </div>
        {/* <p className="analysis-tab-description">
          Bernard is a solid defender who can guard multiple positions. He has
          good lateral quickness and is able to stay in front of his man.
        </p> */}
      </div>
      <div
        style={{
          borderColor: analysisDescription(analysis.playmaking).color,
        }}
        className="analysis-box"
      >
        <h2>Playmaking</h2>{" "}
        <p
          className="analysis-tab-level"
          style={{
            color: analysisDescription(analysis.playmaking).color,
          }}
        >
          {analysisDescription(analysis.playmaking).level}
        </p>
        <PlayerBarChart
          chartType="playmaking"
          player_score={analysis.playmaking}
          player_name={analysis.player_name}
        />
        <div className="expand-section">
          <button
            className="expand-button"
            onClick={() => setShowPlaymaking(!showPlaymaking)}
          >
            {showPlaymaking ? "Hide" : "See Playmaking In Most Recent Games"}
            <ExpandMoreRoundedIcon
              sx={{ fontSize: 35 }}
              className={`expand-icon ${showPlaymaking ? "rotated" : ""}`}
            />
          </button>
          {showPlaymaking && (
            <PlayerLineChart
              chartType="playmaking"
              player_score={analysis.playmaking}
            />
          )}
        </div>
        {/* <p className="analysis-tab-description">
          Bernard is a solid playmaker who can create for himself and others. He
          has good court vision and is able to find the open man.
        </p> */}
      </div>
    </div>
  );
};

export default AnalysisTab;
